<template>
  <div class="card-remote-working">
    <div class="card-remote-working__inner">
      <div class="card-remote-working__row" v-for="key in Object.keys(content)" :key="key">
        <span>{{ $t(`message.sidebar.remoteWorking.labels.${key}`) }}:</span>
        <span :class="`is-${content[key]}`" v-if="key === 'status'" v-html="content[key]"></span>
        <span :class="`is-${key}`" v-else-if="key === 'comment'" v-html="content[key]"></span>
        <span v-else>{{ content[key] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardRemoteWorking',
  components: {

  },
  props: {
    content: {
      type: Object,
      required: true
    },
    display: {
      type: String,
      required: false,
      default: 'large'
    }
  },
  computed: {
    customClass () {
      return [
        `is-${this.content.status}`
      ]
    }
  }
}
</script>

<style lang="scss">
.card-remote-working{
  &__title{
    margin-bottom: layout("spacing");
    padding-bottom: .9rem;
    border-bottom: 1px solid tint(black, 80%);
    font-size: 2.4rem;
  }
  &__inner{
    margin-bottom: 2rem;
  }
  &__row{
    display: flex;
    font-size: 1.3rem;
    span{
      &.is-pending{
        color: colors("warning");
      }
      &.is-approved{
        color: colors("success");
      }
      &.is-comment{
        color: tint(colors("primary"), 30%);
      }
    }
    span:first-child{
      padding-right: 2rem;
      color: tint(black, 50%);
      flex: 0 0 10rem;
    }
    span:last-child{
      text-transform: capitalize;
    }
  }
}
</style>
